import Header from "@/shared/Header";
import Footer from "@/shared/Footer";
import Analitics from "@/shared/Analitics";
import { Error404Container } from "./style";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useRedirectHome } from "./hooks/useRedirectHome";

function PaginaNoEncontrada(props) {

  // START -> redirect home after x seg
  // useRedirectHome();
  // END  

  const { 
		properties,
		menu = {},
		widgets
  } = props

	const bucketsHeader = properties?.bucketsHeader ?? { liveblogs: [] };

  const sectionData = { name: "Error 404", url: null };
  const analyticsData = {
    pageType: "error404",
    nsSite: "clarin-404",
  };

  return (
    <>
      <Analitics {...analyticsData} />
      <Header
        liveblogs={bucketsHeader.liveblogs}
        menu={menu}
        sectionData={sectionData}
      />
      <main>
        <Error404Container>
          <div className="error-title-container">
            <picture className="error-img">
              <img src="/img/paginanoencontrada404/triangle-exclamation-solid.svg" />
            </picture>
            <h1 className="error-title">
              <span>¡OOOPSSS!</span> El contenido que buscás no se encuentra
              disponible.
            </h1>
          </div>

          <div className="error-content">
            <p className="error-text">
              Te invitamos a visitar nuestra{" "}
              <a className="error-link" href="/">
                Portada
              </a>{" "}
              o a recorrer las noticias de{" "}
              <a className="error-link" href="/ultimo-momento">
                Último Momento
              </a>{" "}
              para seguir informándote.
            </p>

            <p className="error-text">
              ¿Preferís conocer la cotización del dólar, jugar o tal vez leer el
              horóscopo? No te preocupes, tenemos lo que necesitás:
            </p>

            <ul className="error-list">
              <li className="error-list-item">
                <FontAwesomeIcon className="error-arrow" icon={faArrowRight} />{" "}
                El dólar,{" "}
                <a className="error-link" href="/economia/divisas-acciones-bonos">
                  minuto a minuto
                </a>
              </li>
              <li className="error-list-item">
                <FontAwesomeIcon className="error-arrow" icon={faArrowRight} />{" "}
                Juegos:{" "}
                <a className="error-link" href="/claringrilla">
                  Claringrilla
                </a>
                ,{" "}
                <a className="error-link" href="juegos/ar/sudoku/facil">
                  Sudoku
                </a>
                ,{" "}
                <a className="error-link" href="/juegos">
                  ¡y más!
                </a>
              </li>
              <li className="error-list-item">
                <FontAwesomeIcon className="error-arrow" icon={faArrowRight} />{" "}
                ¿Qué te depara el destino?{" "}
                <a className="error-link" href="/horoscopo">
                  Leé tu horóscopo
                </a>
              </li>
            </ul>
          </div>
        </Error404Container>
      </main>
      <Footer lastCover={props.properties?.lastCover} />
    </>
  );
}

export default PaginaNoEncontrada;
